import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, Grid, ExcelUpload, FormControl, Table } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_LPCO_SRCH,
    SG_LPCO_LIST_R,
    SG_HS_APP_LIST_R,
    SG_JNT_INSC_LIST_R,
} from "./services/OsciLpcoAsinService";
import { CommonErrors } from "@/comn/components";
import { lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import { COMN_SF_LPCO_SRCH } from "@/tz/go/egaz/osci/lpco/cfgn/comn";
import { MASK } from "@/tz/go/egaz/osci/lpco/comn/LpcoConstants";
/*
 * LPCO Assignment List
 * !== LPCO Assignment List ==!
 */
export const OSCI0201026Q = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0119" },
            { area: "comnCd", comnCd: "OSC0120" },
            { area: "comnCd", comnCd: "OSC0118" },
            { area: "comnCd", comnCd: "OSC0121" },
            { area: "comnCd", comnCd: "OSC0038" },
            { area: "comnCd", comnCd: "OSC0132" },
        ],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0002", "auth_osci0004"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    //    const { dclrNo } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const { openPopup } = usePopup();

    const [srchAsnmtBsopTpCd, setSrchAsnmtBsopTpCd] = useState("ABO03");

    const [lpcoRsptyList, setlpcoRsptyList] = useState(comnUtils.getGridData([]));

    const [orgCdList, setOrgCdList] = useState<any>([]);

    // ORG LPCO LIST
    const [orglpcoRsptyList, setOrglpcoRsptyList] = useState([]);
    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // LPCO List Search !== LPCO List Search ==!
        srchRsptyForm: useForm({
            defaultSchema: SF_LPCO_SRCH,
            defaultValues: {
                srchAsnmtBsopTpCd: srchAsnmtBsopTpCd,
                orgCd: auth.get("orgCd"),
                orgNm: auth.get("orgNm"),
                srchSbmsDtStart: comnUtils.getDate({ m: -1 }),
                srchSbmsDtEnd: comnUtils.getDate(),
                srchAsinMetdCd: ["S", "M", "R", "B", "V"],
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        lpcoRsptyList: useGrid({
            defaultSchema: SG_LPCO_LIST_R,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        hsAppList: useGrid({
            defaultSchema: SG_HS_APP_LIST_R,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        jntInscList: useGrid({
            defaultSchema: SG_JNT_INSC_LIST_R,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const render = {
        grid_lpcoRsptyList: {
            head: {},
            cell: {
                appNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Link
                            to={`${URLS.osci0201027s}/${rowValues.reffId}?asnmtBsopTpCd=${rowValues.asnmtBsopTpCd}&asnmtOfcrTpCd=${rowValues.asnmtOfcrTpCd}`}
                        >{`${rowValues.appNo}`}</Link>
                    );
                },
                aplcTin: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return `[${rowValues.aplcTin}]${rowValues.aplcNm}`;
                },
            },
        },

        grid_hsAppRsptyList: {
            head: {},
            cell: {
                hsAppNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Link
                            to={`${URLS.osci0201027s}/${rowValues.reffId}?asnmtBsopTpCd=${rowValues.asnmtBsopTpCd}&asnmtOfcrTpCd=${rowValues.asnmtOfcrTpCd}`}
                        >{`${rowValues.hsAppNo}`}</Link>
                    );
                },
            },
        },

        grid_jntInscList: {
            cell: {
                tansadNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    console.log(rowValues);
                    const tansadNo = comnUtils.getFormattedValue(rowValues.tansadNo, {
                        type: "text",
                        mask: MASK.TANSAD_NO,
                    });
                    return (
                        <Link
                            to={`${URLS.osci0201028s}/${rowValues.tansadNo}?asnmtOfcrTpCd=${rowValues.asnmtOfcrTpCd}`}
                        >
                            {tansadNo}
                        </Link>
                    );
                },
                reffNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    // Pre-verification bookings have no TANSAD yet, so there is no Reference No. to show
                    // !== 사전검증 예약은 아직 TANSAD가 없어 표시할 Reference No.가 없다 ==!
                    if (!rowValues.reffTin) return "";
                    return `${rowValues.reffTin}-${rowValues.reffYy}-${rowValues.reffSrno}`;
                },
                prcssStatCd: (props: any) => {
                    const { binding, rowValues, value } = props;
                    let prcsStatCdNm = "";

                    switch (rowValues.prcssStatCd) {
                        case "A":
                            prcsStatCdNm = "Received";
                            break;
                        case "B":
                            prcsStatCdNm = "Approved";
                            break;
                        case "D":
                            prcsStatCdNm = "Submitted";
                            break;
                        case "F":
                            prcsStatCdNm = "Returned";
                            break;
                        case "G":
                            prcsStatCdNm = "Re-submit";
                            break;
                        case "H":
                            prcsStatCdNm = "Re-submitted";
                            break;
                    }
                    return prcsStatCdNm;
                },
            },
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        /* Lpco Assignment List !== Lpco Assignment 목록 ==! */
        getRsptyList: useFetch({
            api: (page = grid.lpcoRsptyList.page) => {
                return APIS.getRsptyList(form.srchRsptyForm.getValues(), page, grid.lpcoRsptyList.size);
            },
            enabled: comnUtils.isEmpty(form.srchRsptyForm.errors) && form.srchRsptyForm.isSubmitted,
            key: [grid.lpcoRsptyList.page, grid.lpcoRsptyList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.srchRsptyForm.getValues(),
                    page: grid.lpcoRsptyList.page,
                    size: grid.lpcoRsptyList.size,
                });
            },
            onError: () => {},
            showToast: false,
        }),
        getOrglpcoRsptyList: useFetch({
            api: (data) => {
                return lpcoUtils.getOrgLpcoList(data);
            },
            onSuccess: (data) => {
                console.log("getOrglpcoRsptyList onSuccess ", data);
                setOrglpcoRsptyList(data || []);
                // Search List
                //handler.getLpcoRsptyList();
            },
            onError: () => {},
            showToast: false,
        }),
        getOrgCdList: useFetch({
            api: () => {
                return lpcoUtils.getOrgCdList();
            },
            onSuccess: (data) => {
                const orgCdList = data || [];
                orgCdList.map((item: any) => {
                    if (item.orgAbrtNm) {
                        item.label = "[" + item.orgAbrtNm + "] " + item.label;
                    }
                });

                setOrgCdList(orgCdList);
            },
            onError: () => {},
            showToast: false,
        }),
        getInscRsptyList: useFetch({
            api: (page = grid.jntInscList.page) => {
                return APIS.getRsptyList(form.srchRsptyForm.getValues(), page, grid.jntInscList.size);
            },
            enabled: comnUtils.isEmpty(form.srchRsptyForm.errors) && form.srchRsptyForm.isSubmitted,
            key: [grid.jntInscList.page, grid.jntInscList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.srchRsptyForm.getValues(),
                    page: grid.jntInscList.page,
                    size: grid.jntInscList.size,
                });
            },
            onError: () => {},
            showToast: false,
        }),
        getHsAppRsptyList: useFetch({
            api: (page = grid.hsAppList.page) => {
                return APIS.getRsptyList(form.srchRsptyForm.getValues(), page, grid.hsAppList.size);
            },
            enabled: comnUtils.isEmpty(form.srchRsptyForm.errors) && form.srchRsptyForm.isSubmitted,
            key: [grid.hsAppList.page, grid.hsAppList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.srchRsptyForm.getValues(),
                    page: grid.hsAppList.page,
                    size: grid.hsAppList.size,
                });
            },
            onError: () => {},
            showToast: false,
        }),
    };
    /*
     * 화면에서 사용하는 이벤트, 함수를 선언
     * 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * fetch 를 호출 하는 메소드: fetch 명과 동일하게 작성
     * 버튼이나 그리드의 이벤트의 경우 : [이벤트종류]_[이벤트대상타입]_[이벤트대상명]
     * 이벤트 대상 타입 : Btn , Grid ... 카멜표기법으로 표시, 첫글자 대문자
     * 이벤트 명 : 카멜표기법으로 표시, 첫글자 대문자
     *
     * const handler = {
     *      [handler 이름] : ()=>{ 함수 },
     *      click_Btn_Save : 저장버튼 클릭
     *      click_Grid_RpckItmAppList : 재포장 품목 신청서 그리드 클릭
     *      ...
     * }
     */
    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        /* Lpco Assignment List !== Lpco Assignment 목록 ==! */
        getRsptyList: (srchAsnmtBsopTpCd: any) => {
            form.srchRsptyForm.handleSubmit(
                (data) => {
                    if (srchAsnmtBsopTpCd == "ABO03") {
                        grid.lpcoRsptyList.setPage(0);
                        fetch.getRsptyList.fetch(0);
                    } else if (srchAsnmtBsopTpCd == "ABO04") {
                        grid.jntInscList.setPage(0);
                        fetch.getInscRsptyList.fetch(0);
                    } else if (srchAsnmtBsopTpCd == "ABO02") {
                        grid.hsAppList.setPage(0);
                        fetch.getHsAppRsptyList.fetch(0);
                    }
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        setInit: async () => {
            // 기관 LPCO SELECT 목록
            await fetch.getOrglpcoRsptyList.fetch(auth.get("orgCd"));

            const srchAsnmtBsopTpCd = form.srchRsptyForm.getValue("srchAsnmtBsopTpCd");
            if (srchAsnmtBsopTpCd == "ABO02" && orgCdList.length == 0) fetch.getOrgCdList.fetch();
            setSrchAsnmtBsopTpCd(srchAsnmtBsopTpCd);
            // list search
            handler.getRsptyList(srchAsnmtBsopTpCd);
        },
        ketOnTansadPaste: (e: any) => {
            const data = e.clipboardData.getData("Text").replace(/[^\w]/g, "");
            if (data.length <= 4) {
                form.srchRsptyForm.setValue("cstmOfceCd", data);
            } else if (data.length > 4 && data.length <= 6) {
                form.srchRsptyForm.setValue("cstmOfceCd", data.substring(0, 4));
                form.srchRsptyForm.setValue("tansadYy", data.substring(4, 6));
            } else if (data.length > 6) {
                form.srchRsptyForm.setValue("cstmOfceCd", data.substring(0, 4));
                form.srchRsptyForm.setValue("tansadYy", data.substring(4, 6));
                form.srchRsptyForm.setValue("tansadSrno", data.substring(6, 13));
            }
        },
    };

    useEffect(() => {
        // search condition setting
        lpcoUtils.setSrchFormFromStore(form.srchRsptyForm, pgeStore);

        handler.setInit();
    }, []);

    return (
        <Page
        // id={pgeUid}
        // title={t("T_ASNMT_LST")}
        // navigation={{
        //     base: comnEnvs.base,
        //     nodes: [...BASE.nodes, { path: "/lpco/app/asin/osci0201026q", label: "T_ASNMT_LST" }],
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.srchRsptyForm.schema.orgNm}></Group.Control>
                            <Group.Control
                                {...form.srchRsptyForm.schema.srchAsnmtBsopTpCd}
                                onChange={(val: any) => {
                                    setSrchAsnmtBsopTpCd(val);
                                    if (val != "ABO03") {
                                        form.srchRsptyForm.setValue("srchAppCdNo", "");
                                        form.srchRsptyForm.setValue("srchUcrNo", "");

                                        form.srchRsptyForm.setValue("srchAplcTin", "");
                                        form.srchRsptyForm.setValue("srchAppNo", "");

                                        form.srchRsptyForm.setValue("srchHsAppNo", "");
                                        form.srchRsptyForm.setValue("srchOrgCd", "");
                                        form.srchRsptyForm.setValue("srchOrgChpnNm", "");
                                    }

                                    if (val == "ABO02" && orgCdList.length == 0) {
                                        fetch.getOrgCdList.fetch();
                                    }
                                    form.srchRsptyForm.reset();
                                    form.srchRsptyForm.setValue("srchAsnmtBsopTpCd", val);
                                    handler.getRsptyList(val);
                                }}
                            ></Group.Control>
                        </Group.Row>
                        {srchAsnmtBsopTpCd == "ABO03" && (
                            <>
                                <Group.Row>
                                    <Group.Control
                                        {...form.srchRsptyForm.schema.srchAppCdNo}
                                        options={orglpcoRsptyList}
                                    ></Group.Control>
                                    <Group.Control {...form.srchRsptyForm.schema.srchUcrNo}></Group.Control>
                                </Group.Row>
                            </>
                        )}
                        {srchAsnmtBsopTpCd == "ABO03" && (
                            <Group.Row>
                                <Group.Control {...form.srchRsptyForm.schema.srchAppNo}></Group.Control>
                                <Group.Control {...form.srchRsptyForm.schema.srchAplcTin}></Group.Control>
                            </Group.Row>
                        )}

                        {srchAsnmtBsopTpCd == "ABO02" && (
                            <>
                                <Group.Row>
                                    <Group.Control
                                        {...form.srchRsptyForm.schema.srchOrgCd}
                                        options={orgCdList}
                                    ></Group.Control>
                                    <Group.Control {...form.srchRsptyForm.schema.srchHsAppNo}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.srchRsptyForm.schema.srchOrgChpnNm}></Group.Control>
                                </Group.Row>
                            </>
                        )}

                        <Group.Row>
                            {srchAsnmtBsopTpCd == "ABO04" && (
                                <Group.Control {...form.srchRsptyForm.schema.srchJntAsnmtOfcrTpCd}></Group.Control>
                            )}
                            {srchAsnmtBsopTpCd != "ABO04" && (
                                <Group.Control {...form.srchRsptyForm.schema.srchAsnmtOfcrTpCd}></Group.Control>
                            )}
                            <Group.Control {...form.srchRsptyForm.schema.srchAsnmtOfcrId}></Group.Control>
                        </Group.Row>
                        {(!srchAsnmtBsopTpCd || srchAsnmtBsopTpCd == "ABO03") && (
                            <>
                                <Group.Row>
                                    <Group.Control {...form.srchRsptyForm.schema.srchAsinMetdCd}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control
                                        {...form.srchRsptyForm.schema.srchSbmsDt}
                                        rangeButton={0}
                                        controlSize={10}
                                    />
                                </Group.Row>
                            </>
                        )}
                        {srchAsnmtBsopTpCd == "ABO04" && (
                            <Group.Row>
                                <Group.Label {...form.srchRsptyForm.schema.tansadNo}></Group.Label>
                                <Group.Field size={4}>
                                    <Group.Control
                                        {...form.srchRsptyForm.schema.cstmOfceCd}
                                        onPaste={(e: any) => {
                                            e.preventDefault();
                                            handler.ketOnTansadPaste(e);
                                        }}
                                    />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.srchRsptyForm.schema.tansadYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.srchRsptyForm.schema.tansadSrno} />
                                </Group.Field>
                                <Group.Control {...form.srchRsptyForm.schema.godsLoctWrhsCd}></Group.Control>
                            </Group.Row>
                        )}
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.srchRsptyForm.reset();
                                    form.srchRsptyForm.setValue("srchAsnmtBsopTpCd", srchAsnmtBsopTpCd);
                                    form.srchRsptyForm.setValues({ ...lpcoUtils.orgInfo });
                                    form.srchRsptyForm.setValue("orgNm", auth.get("orgNm"));
                                    handler.getRsptyList(srchAsnmtBsopTpCd);
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getRsptyList(srchAsnmtBsopTpCd);
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Title title={"L_SRCH_RSTS"} titleSize={2}></Group.Title>
                    {/*
                     * 그리드
                     * @ 그리드 스키마 주입 : {...grid.[그리드이름].grid}
                     * @ 데이터 data={fetch.[fetch 명].data?.[api 리턴 vo 명]}
                     * @ 셀클릭이벤트 연결 : onCellClick={handler.[그리드 이벤트 핸들러명]}
                     */}
                    {srchAsnmtBsopTpCd == "ABO02" && (
                        <Grid
                            {...grid.hsAppList.grid}
                            data={fetch.getHsAppRsptyList.data?.rsptyList}
                            render={render.grid_hsAppRsptyList}
                        />
                    )}

                    {srchAsnmtBsopTpCd == "ABO03" && (
                        <Grid
                            {...grid.lpcoRsptyList.grid}
                            data={fetch.getRsptyList.data?.rsptyList}
                            render={render.grid_lpcoRsptyList}
                        />
                    )}

                    {srchAsnmtBsopTpCd == "ABO04" && (
                        <Grid
                            {...grid.jntInscList.grid}
                            data={fetch.getInscRsptyList.data?.rsptyList}
                            render={render.grid_jntInscList}
                        />
                    )}
                </Group.Body>
            </Group>
        </Page>
    );
};
